import { css } from "@emotion/react";
import { CSS_MQ } from "../../styles/breakpoints";
import { pdpStickyStyles } from "./PDP_SingleImageCarousel/styles";

export const divStyles = css`
  ${CSS_MQ.atMostSm} {
    position: relative;
    margin-bottom: 4px;

    --height: 300px;
    height: var(--height);

    display: grid;
    grid-auto-flow: column;
  }

  ${CSS_MQ.atLeastMd} {
    ${pdpStickyStyles};

    display: grid;
    grid-auto-flow: row;

    grid-gap: 30px;
    --aspect-ratio: 4/3;
  }

  .one-image {
    ${CSS_MQ.atLeastLg} {
      --aspect-ratio: 2/3;
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }
  }

  .multiple-images {
    ${CSS_MQ.atLeastLg} {
      --aspect-ratio: 4/3;
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
`;
